import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from 'react-responsive';
import './FloatingAddButton.scss';

const FloatingAddButton = ({ onClick, entityName, dataLoaded }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1023px)' });
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (isDesktop && dataLoaded) {
      // Start expanded
      setIsExpanded(true);
      // Shrink after 4 seconds
      const timer = setTimeout(() => {
        setIsExpanded(false);
      }, 4000);
      return () => clearTimeout(timer);
    } else if (!isDesktop) {
      setIsExpanded(false);
    }
  }, [isDesktop, dataLoaded]);

  const buttonClass = `floating-add-btn ${isDesktop ? 'desktop' : ''} ${isExpanded ? 'expanded' : ''}`;
  const text = `הוספת ${entityName}`;

  return (
    <button className={buttonClass} onClick={onClick} data-testid="floating-add-button">
        <FontAwesomeIcon icon={faPlus} />
      {isDesktop && isExpanded && <span className="btn-text">{text}</span>}
    </button>
  );
};

export default FloatingAddButton;